import React from 'react';
import cx from 'classnames';
import { Loader } from '@saviynt/design-system';

import './AppLoading.css';

const AppLoading = ({ isMfe }) => (
  <div className={cx('AppLoading', isMfe && 'AppLoading--isMfe')}>
    <Loader kind="loop" format="main" color="brand" size="large" />
  </div>
);
export default AppLoading;
